/** Site team segment in player profile URLs, e.g. `/team/nomads/...` */
export const DEFAULT_TEAM_SLUG = 'nomads';

/** Convert a display name to the URL slug (lowercase, hyphen-separated). */
export function playerDisplayNameToPathSlug(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, '-');
}

/** Build the canonical player profile path. */
export function playerProfilePath(teamSlug: string, playerFullName: string): string {
  return `/team/${teamSlug}/${playerDisplayNameToPathSlug(playerFullName)}`;
}
